import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-record-delete',
  templateUrl: './record-delete.component.html',
  styleUrls: ['./record-delete.component.scss'],
})
export class RecordDeleteComponent implements OnInit {
  @Input() disabled?: boolean;
  @Output() delete = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit(): void {}

  onClick(): void {
    this.delete.emit();
  }
}
